// Single Firebase app instance shared by analytics (App.js), the admin panel
// (auth) and the articles feature (Firestore for metadata — files go to
// DigitalOcean Spaces, see src/lib/doSpaces.js). Config comes from
// REACT_APP_* env vars (see .env) instead of being hardcoded per-file.
import { getApps, initializeApp } from "firebase/app";
import { getAnalytics, isSupported as analyticsIsSupported } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);

// Analytics only works in the browser and only when supported (e.g. not blocked
// by an ad-blocker / not in SSR); resolve lazily instead of at module load.
export let analytics;
export const analyticsReady =
  typeof window !== "undefined"
    ? analyticsIsSupported().then((supported) => {
        if (supported) analytics = getAnalytics(app);
        return analytics;
      })
    : Promise.resolve(undefined);
